// Compact POS marginalia. The な/い glyph for adjectives is the entire
// reason this exists — see Dan's "それは いい adjective" post.
// Handles both English (jmdict-derived) and Japanese (kiri-derived)
// POS strings so the same tile renders the same tag regardless of source.

const ENGLISH_TAGS: Record<string, string> = {
  noun: "N",
  verb: "V",
  adverb: "ADV",
  particle: "PART",
  conjunction: "CONJ",
  interjection: "INT",
  expression: "EXP",
  pronoun: "PRO",
  prefix: "PRE",
  suffix: "SUF",
  numeric: "NUM",
  copula: "COP",
};

// Kiri / UniDic Japanese POS tags. 形容詞 = い-adjective; 形状詞 =
// な-adjective. The な/い glyph in the rendered tag is the whole point.
const JP_TAGS: [string, string][] = [
  ["形容詞", "ADJ-い"],
  ["形状詞", "ADJ-な"],
  ["連体詞", "ADJ-連"], // pre-noun / "rentaishi" — neither な nor い
  ["動詞", "V"],
  ["名詞", "N"],
  ["代名詞", "PRO"],
  ["副詞", "ADV"],
  ["助詞", "PART"],
  ["助動詞", "AUX"],
  ["接続詞", "CONJ"],
  ["感動詞", "INT"],
  ["接頭辞", "PRE"],
  ["接尾辞", "SUF"],
  ["数詞", "NUM"],
  ["記号", "SYM"],
  ["補助記号", "SYM"],
];

export function posLabel(pos: string): string {
  if (!pos) return "—";
  for (const [jp, tag] of JP_TAGS) {
    if (pos.includes(jp)) return tag;
  }
  const lower = pos.toLowerCase();
  if (lower.includes("na-adjective") || lower.includes("na adjective")) {
    return "ADJ-な";
  }
  if (lower.includes("i-adjective") || lower.includes("i adjective")) {
    return "ADJ-い";
  }
  for (const [k, v] of Object.entries(ENGLISH_TAGS)) {
    if (lower.includes(k)) return v;
  }
  // Fallback: take first whitespace-separated token, uppercase, cap at 6.
  const first = pos.split(/[\s,]/)[0] ?? pos;
  return first.toUpperCase().slice(0, 6) || "—";
}
